export function normalizeColumnName(name: string): string {
  if (!name) return ''
  return name
    .toLowerCase()
    .replace(/\s*\([^)]*\)\s*/g, '')
    .replace(/[áàâãä]/g, 'a')
    .replace(/[éèêë]/g, 'e')
    .replace(/[íìîï]/g, 'i')
    .replace(/[óòôõöº]/g, 'o')
    .replace(/[úùûü]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[ñ]/g, 'n')
    .replace(/[ª]/g, 'a')
    .replace(/\s+/g, ' ')
    .trim()
}

export function extractPossibleNames(name: string): string[] {
  const normalized = normalizeColumnName(name)
  const names = [normalized]
  
  if (normalized.includes(' = ')) {
    const parts = normalized.split(' = ')
    names.push(parts[0].trim())
    names.push(parts[1].trim())
  }
  
  if (normalized.includes(' - ')) {
    const parts = normalized.split(' - ')
    names.push(parts[0].trim())
    names.push(parts[1].trim())
  }
  
  return names
}

export const columnMappingRules: { [key: string]: string } = {
  acabamento: 'finishing',
  fabricacao: 'fabrication',
  'cmc total': 'totalCmc',
  comprimento: 'lengthInMm',
  'custo por kg': 'costPerKg',
  'custo por mm': 'costPerMm',
  'custo total': 'totalCost',
  codigo: 'code',
  'data de recebimento': 'receivedDate',
  densidade: 'density',
  'dimensao 1': 'dimension1',
  'dimensao 2': 'dimension2',
  formato: 'format',
  fornecedor: 'supplier',
  material: 'material',
  ncm: 'ncm',
  'n de corrida': 'heatNumber',
  'no de corrida': 'heatNumber',
  'numero de corrida': 'heatNumber',
  'n de rastreamento': 'trackingNumber',
  'no de rastreamento': 'trackingNumber',
  'numero de rastreamento': 'trackingNumber',
  rastreamento: 'trackingNumber',
  re: 'trackingNumber',
  descricao: 'description',
  caracteristica: 'characteristic',
  familia: 'family',
  'ordem de compra': 'purchaseOrder',
  'pais de origem': 'originCountry',
  'peso total': 'totalWeight',
  peso: 'totalWeight',
  quantidade: 'quantity',
  'tratamento termico': 'heatTreatment',
  unidade: 'measurementUnit',
  rua: 'stockStreet',
  prateleira: 'shelf',
  localizacao: 'stockLocation',
}

export function autoMapSpreadsheetHeaders(headers: string[]): { [key: string]: string } {
  const mapping: { [key: string]: string } = {}
  
  headers.forEach((header) => {
    const possibleNames = extractPossibleNames(header)
    let mappedValue: string | undefined
    let matchedName: string | undefined
    
    for (const name of possibleNames) {
      if (columnMappingRules[name]) {
        mappedValue = columnMappingRules[name]
        matchedName = name
        break
      }
    }
    
    if (mappedValue) {
      mapping[header] = mappedValue
    }
  })
  
  return mapping
}
